module.exports = __webpack_public_path__ + "assets/img/c908-gy.svg";